import React from 'react'
import { styled } from '../../stitches.config'
import {
    PopoverContent,
    PopoverRoot,
    PopoverTrigger,
} from '@/src/common/components/elements/Buttons/Popover'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import { FAQ_PAGE } from '../pg-plus/constants'

const TextContainer = styled('div', {
    mb: '8px',
    lh: '1.65rem',
    fontSize: '$5',
    color: '$dark',
    '& span': {
        fontWeight: 'bold',
    },
})

interface ILineItemDetails {
    email: string
    phone: string
}

const LineItemDetailsVirtual = ({
    email = '',
    phone = '',
}: ILineItemDetails) => {
    return (
        <TextContainer data-testid={'contact-info'}>
            <span>To:</span> {phone || email}
            &nbsp;
            <PopoverRoot>
                <PopoverTrigger variant={'default'}>
                    <FontAwesomeIcon icon={faInfo} />
                </PopoverTrigger>
                <PopoverContent>
                    For security purposes&#44; your recipient&#39;s details are
                    intentionally obscured and not the correct length. For more
                    information, see our list of{' '}
                    <Link href={FAQ_PAGE} aria-label={'faq-button'}>
                        frequently asked questions
                    </Link>
                    .
                </PopoverContent>
            </PopoverRoot>
        </TextContainer>
    )
}
export default LineItemDetailsVirtual
